/* global YT */
/* global videojs */

const SELECTOR = '.js-header-video';

const isReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

function getYouTubeId(url) {
    if (!url) {
        return null;
    }

    const regex = /(?:youtube\.com\/(?:.*[?&]v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const match = url.match(regex);

    return match ? match[1] : null;
}

async function loadYouTubeAPI() {
    return new Promise(resolve => { // eslint-disable-line
        const tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';

        window.onYouTubeIframeAPIReady = () => {
            resolve();
            delete window.onYouTubeIframeAPIReady;
        }

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

export async function init() {
    const headerElement = document.querySelector(SELECTOR);

    if (!headerElement) {
        return;
    }

    const videoContainerElement = headerElement.querySelector('.video-container');

    if (!videoContainerElement) {
        return;
    }

    const playButtons = headerElement.querySelectorAll('.page-hero__play');

    const toggleButtonState = isPlaying => {
        for (const playButton of playButtons) {
            playButton.querySelector('div').innerHTML = isPlaying
                ? '<svg class="o-icon o-icon--circle-pause"><use xlink:href="#circle-pause"></use></svg>'
                : '<svg class="o-icon o-icon--play-circle"><use xlink:href="#play-circle"></use></svg>';

            playButton.querySelector('span').textContent = isPlaying ? 'Pause' : 'Play';
        }
    }

    const videoUrl = videoContainerElement.dataset.url;

    if (videoUrl) {
        const videoId = getYouTubeId(videoUrl);

        if (!videoId) {
            return;
        }

        videoContainerElement.id = `youtube-${videoId}`;

        await loadYouTubeAPI();

        const player = new YT.Player(videoContainerElement.id, {
            videoId,
            playerVars: {
                controls: 0,
                autoplay: 0,
                mute: 1,
                disablekb: 1,
                enablejsapi: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                showinfo: 0,
                rel: 0,
                height: 1200,
                width: 675,
                autohide: 1,
                loop: 1,
                playlist: videoId,
            },
            events: {
                onReady: () => {
                    videoContainerElement.classList.add('video-container--loaded');

                    for (const playButton of playButtons) {
                        playButton.addEventListener('click', () => {
                            if (player.getPlayerState() === YT.PlayerState.PLAYING) {
                                player.pauseVideo();
                            } else {
                                player.playVideo();
                            }
                        });
                    }

                    if (!isReducedMotion) {
                        player.playVideo();
                    }
                },
                onStateChange: event => {
                    if (event.data === YT.PlayerState.ENDED) {
                        // if loop doesn't work
                        // player.seekTo(0);
                        // player.playVideo();
                    } else if (event.data === YT.PlayerState.PLAYING) {
                        toggleButtonState(true);
                    } else if (event.data === YT.PlayerState.PAUSED) {
                        toggleButtonState(false);
                    }
                },
            },
        });
    } else {
        const videoUrl = videoContainerElement.dataset.videoUrl;
        const { account, playerName, embed, videoId } = videoUrl.match(/^https:\/\/players\.brightcove\.net\/(?<account>\d+)\/(?<playerName>\w+)_(?<embed>\w+)\/index.html\?videoId=(?<videoId>\d+)$/)?.groups;
        const videoJsEl = document.createElement('video-js');
        videoJsEl.setAttribute('data-account', account);
        videoJsEl.setAttribute('data-player', playerName);
        videoJsEl.setAttribute('data-embed', embed);
        videoJsEl.setAttribute('data-video-id', videoId);
        videoJsEl.setAttribute('controls', '');
        videoJsEl.setAttribute('data-playlist-id', '');
        videoJsEl.setAttribute('data-application-id', '');
        videoJsEl.classList.add('vjs-fluid');

        videoContainerElement.appendChild(videoJsEl);
        // Generate something similar to this
        // <video-js
        //     data-account="5791559000001"
        //     data-player="default"
        //     data-embed="default"
        //     controls=""
        //     data-video-id="6385933738112"
        //     data-playlist-id=""
        //     data-application-id=""
        //     class="vjs-fluid"></video-js>

        const scriptEl = document.createElement('script');
        scriptEl.src = `https://players.brightcove.net/${account}/${playerName}_${embed}/index.min.js`;
        scriptEl.addEventListener('load', async () => {

            const player = videojs.getAllPlayers()[0];

            if (!player) {
                return;
            }

            // Wait for videojs to be ready
            await new Promise(resolve => {
                player.ready(() => {
                    resolve();
                });
            });

            videoContainerElement.classList.add('video-container--loaded');

            for (const playButton of playButtons) {
                playButton.addEventListener('click', () => {
                    if (player.paused()) {
                        player.play();
                    } else {
                        player.pause();
                    }
                });
            }

            player.on('playing', () => {
                toggleButtonState(true);
            });

            player.on('pause', () => {
                toggleButtonState(false);
            });

            player.on('ended', () => {
                player.play();
            });

            if (!isReducedMotion) {
                player.muted(true);
                player.play();
            }
        });
        document.head.appendChild(scriptEl);
    }
}
